import { createSelector } from '@ngrx/store';
import { getCatalogState } from '../feature.selector';
import { CatalogState } from '../state';

export const getCustomPlpConfigContent = createSelector(
  getCatalogState,
  (state: CatalogState) => state && state.customplp
);

export const getCustomPlpSeoContent = createSelector(
  getCatalogState,
  (state: CatalogState) => state && state.customplp && state.customplp.seoContent
);

export const getCustomPlpTitle = createSelector(
  getCatalogState,
  (state: CatalogState) => state && state.customplp && state.customplp.title
);
